import { useState } from 'react';
import { useSnackbar } from 'notistack';

import { Tag } from '../types/tag.type';
import HttpClient from '../../shared/infrastructures/clients/http.client';
import { extractTranslatedApiErrorMessage } from '../../shared/utils/translate-api-error.util';
import { ADMIN_TAGS_API_PATHS } from '../constants/tags-api-paths.constants';

type UseCreateTagResult = {
  isSubmitting: boolean;
  createTag: (name: string) => Promise<Tag | null>;
};

export function useCreateTag(): UseCreateTagResult {
  const { enqueueSnackbar } = useSnackbar();
  const [isSubmitting, setIsSubmitting] = useState(false);

  const createTag = async (name: string): Promise<Tag | null> => {
    setIsSubmitting(true);

    try {
      const tag = await HttpClient.post<Tag>(ADMIN_TAGS_API_PATHS.CREATE_TAG, { name });

      enqueueSnackbar('Le tag a été créé', { variant: 'success' });
      return tag;
    } catch (error) {
      enqueueSnackbar(extractTranslatedApiErrorMessage(error, 'Une erreur est survenue lors de la création du tag'), {
        variant: 'error',
      });
      return null;
    } finally {
      setIsSubmitting(false);
    }
  };

  return { isSubmitting, createTag };
}
